<template>
  <navigation-bar></navigation-bar>

  <div class="email-container">
    <!-- Linke Seite: Liste der E-Mails -->
    <div class="email-list">
      <h4> <br> </h4>
      <table>
        <thead>
          <tr>
            <th>Küldő email</th>
            <th>Küldő neve</th>
            <th>Tárgy</th>
            <th>Időpont</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="email in emails"
            :key="email.id"
            @click="selectEmail(email)"
            :class="{ selected: selectedEmail && selectedEmail.id === email.id }"
          >
            <td>{{ email.from_email }}</td>
            <td>{{ email.from_name }}</td>
            <td>{{ email.subject }}</td>
            <td>{{ email.receivedDateTime }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Rechte Seite: Details der ausgewählten E-Mail -->
    <div class="email-details" v-if="selectedEmail">
      <h4> <br> </h4>
      <div><strong>Küldő:</strong> {{ selectedEmail.from_name }} ({{ selectedEmail.from_email }})</div>
      <div><strong>Címzett:</strong> {{ selectedEmail.to_email }}</div>
      <div><strong>CC:</strong> {{ selectedEmail.cc_email || '--' }}</div>
      <div><strong>Időpont:</strong> {{ selectedEmail.receivedDateTime }}</div>
      
      
      <div>
        <strong>Melléklet:</strong>
        <span v-if="attachmentList.length">
          <span v-for="(file, index) in attachmentList" :key="index">
            <a href="#" @click.prevent="onAttachmentClick(file)">{{ file }}</a>
            <span v-if="index < attachmentList.length - 1">, </span>
          </span>
        </span>
        <span v-else>--</span>
      </div>
      
      
      
      <div class="email-body">
        <div v-html="sanitizedHtml"></div>
      </div>
      

      <div v-if="xlsxHtml" class="xlsx-preview">
        <div v-html="xlsxHtml"></div>
      </div>


      <div v-if="pdfUrl" class="pdf-preview">
        <iframe :src="pdfUrl" width="100%" height="500px" style="border: 1px solid #ccc;"></iframe>
      </div>

      <div v-if="imageUrl" class="image-preview">

        <img :src="imageUrl" style="max-width: 100%; max-height: 500px; border: 1px solid #ccc;" />
      </div>



    </div>
  </div>
</template>

<script>
import axiosInstance from '@/axiosInstance';
import DOMPurify from 'dompurify';
import * as XLSX from 'xlsx'; // Ganz oben einfügen

export default {

  

  data() {
    return {
      emails: [],
      selectedEmail: null,
      errorMessage: '',
      loading: false,
      xlsxHtml: '', // Neu: HTML für XLSX-Inhalt
      pdfUrl: '', // 👈 neu für Vorschau
      imageUrl: '',
    };
  },
  computed: {
    sanitizedHtml() {
      return this.selectedEmail && this.selectedEmail.bodyHtml
        ? DOMPurify.sanitize(this.selectedEmail.bodyHtml)
        : '';
    },
    attachmentList() {
        // Falls `attachments` leer oder undefined ist, liefern wir ein leeres Array zurück
        if (!this.selectedEmail.attachments) return [];
        // Wenn attachments eine durch Kommas getrennte Zeichenkette ist, splitten und trimmen wir:
        return this.selectedEmail.attachments.split(',').map(item => item.trim());
      }
    


  },
  methods: {

    async fetchAndDisplayImage(fileName) {
  if (!this.selectedEmail) return;

  const postData = {
    message_id: this.selectedEmail.id,
    file_name: fileName
  };

console.log('jpg postData',postData);

  try {
    const response = await axiosInstance.post('/emails/get_emailAttachment.php', postData);

    if (response.status === 200 && response.data?.data?.length > 0) {
      const fileData = response.data.data[0];
      const base64 = fileData.base64_content;
      const contentType = fileData.content_type || 'image/jpeg';

      const imageUrl = `data:${contentType};base64,${base64}`;

      this.imageUrl = imageUrl;
      this.xlsxHtml = '';
      this.pdfUrl = '';
    } else {
      alert('Hiba a file letöltésénél.');
    }
  } catch (err) {
    console.error('Fehler beim Abrufen des Bildes:', err);
  }
},


    async fetchAndDisplayPdf(fileName) {
        if (!this.selectedEmail) return;

        const postData = {
          message_id: this.selectedEmail.id,
          file_name: fileName
        };

        try {
          const response = await axiosInstance.post('/emails/get_emailAttachment.php', postData);

          if (response.status === 200 && response.data?.data?.length > 0) {
            const fileData = response.data.data[0];
            const base64 = fileData.base64_content;

            // PDF → Blob-URL erzeugen
            const binary = atob(base64);
            const len = binary.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
              bytes[i] = binary.charCodeAt(i);
            }

            const blob = new Blob([bytes], { type: 'application/pdf' });
            const url = URL.createObjectURL(blob);

            this.pdfUrl = url; // 👈 PDF Vorschau aktivieren
            this.xlsxHtml = ''; // falls vorher Excel angezeigt wurde, löschen

          } else {
            alert('Hiba a PDF-file letöltésénél.');
          }
        } catch (err) {
          console.error('Fehler beim Abrufen der PDF-Datei:', err);
        }
      },




    async fetchAndDisplayXlsx(fileName) {

      console.log('SELECTED EMAIL:', this.selectedEmail);

      if (!this.selectedEmail) return;

      const postData = {
        message_id: this.selectedEmail.id,
        file_name: fileName
      };

console.log('Attachment_postData',postData);

      try {
        const response = await axiosInstance.post('/emails/get_emailAttachment.php', postData);

        if (
          response.status === 200 &&
          response.data?.data?.length > 0
        ) {
          const fileData = response.data.data[0];
          const base64 = fileData.base64_content;

          // Base64 → Binär
          const binary = atob(base64);
          const len = binary.length;
          const bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
            bytes[i] = binary.charCodeAt(i);
          }

          // XLSX parsen
          const workbook = XLSX.read(bytes, { type: 'array' });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];

          // Sheet in HTML konvertieren
          const html = XLSX.utils.sheet_to_html(sheet, {
            editable: false,
            header: "<h4>📄 Excel-megtekintés:</h4>",
            id: "excel-preview-table" // 👈 wichtig, um CSS direkt anzusprechen
          });

          // HTML speichern zur Anzeige
          this.xlsxHtml = html;
        } else {
          alert('Hiba az xlsx file letöltésénél.');
        }
      } catch (err) {
        console.error('Fehler beim Abrufen:', err);
        alert('Ein Fehler ist aufgetreten.');
      }
    },


    onAttachmentClick(fileName) {
  const lower = fileName.toLowerCase();

  if (lower.endsWith('.xlsx')) {
    this.fetchAndDisplayXlsx(fileName);
  } else if (lower.endsWith('.pdf')) {
    this.fetchAndDisplayPdf(fileName);
  } else if (lower.endsWith('.jpg') || lower.endsWith('.jpeg') || lower.endsWith('.png')) {
    this.fetchAndDisplayImage(fileName);
  } else {
    alert('Csak XLSX, PDF vagy kép formátum tekinthető meg.');
  }
},



   // fetchXlsxFile(fileName) {
      // Hier wäre die Stelle, an der du z.B. per Axios
      // eine Anfrage machst, um den base64-String zu laden.
      // Beispiel:
      // axios.get(`/api/get_attachment.php?fileName=${encodeURIComponent(fileName)}`)
      //   .then((response) => {
      //     // response.data -> enthält den base64-String und ggf. den MIME-Type
      //     // -> in ein Blob umwandeln und Download oder Viewer öffnen
      //   })
      //   .catch((err) => console.error(err));
   // },



    async fetchEmails() {
      this.loading = true;
      const postData = {
        fsz: "bonyhad",
        ceg_az: 1
      };

      try {
        const url = '/emails/list_emails.php';
        const response = await axiosInstance.post(url, postData);

        if (response.status === 200 && response.data.data && response.data.data.length > 0) {
          this.emails = response.data.data;
          this.selectedEmail = this.emails[0]; // Wählt automatisch die erste E-Mail aus
        } else {
          this.errorMessage = 'Fehler beim Abrufen der E-Mails: ' + response.statusText;
        }
      } catch (error) {
        this.errorMessage = 'Fehler beim Abrufen der E-Mails: ' + error.message;
      } finally {
        this.loading = false;
      }
    },
    selectEmail(email) {
      this.selectedEmail = email;
      this.xlsxHtml = ''; // <<< Reset der Excel-Vorschau
      this.pdfUrl = ''; // << Reset für PDF
      this.imageUrl = '';
    },
  },
  mounted() {
    this.fetchEmails();
  },
};
</script>

<style scoped>

.email-container {
  display: flex;
  height: calc(100vh - 60px); /* passt sich an: obere Leiste rausrechnen */
  overflow: hidden; /* verhindert globale Scrollbar */
  gap: 10px;
}


.email-list {
  flex: 0 0 35%; /* fixiert auf 35% */
  font-size: 12px; /* kleinere Schrift */
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 100%;
  box-sizing: border-box;
}

.email-details {
  flex: 0 0 64%; /* größerer Bereich */
  overflow-y: auto;
  overflow-x: hidden;
    max-height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.email-details > div:not(.email-body):not(.xlsx-preview) {
  font-size: 13px;
  line-height: 1.4;
}


.email-list table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* Alle Spalten gleich breit */
}

.email-list th,
.email-list td {
  border: 1px solid #ccc;
  padding: 6px 4px; /* engerer Padding */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px; /* kleinere Schrift */
}

.email-list tr:hover {
  background-color: #f9f9f9;
  cursor: pointer;
}

.email-list .selected {
  background-color: #dfeeff;
}

.email-details div {
  margin-bottom: 10px;
  text-align: left; /* Stellt sicher, dass alle Texte linksbündig sind */
}


.email-body {
  margin-top: 20px;
  border: 1px solid #ccc;
  padding: 10px;
  background-color: #f9f9f9;
  overflow: auto;
  max-height: 300px;
  text-align: left;
  font-size: 14px;
  scrollbar-width: auto;
  scrollbar-color: #999 #e0e0e0;

  padding-bottom: 20px; /* Platz für horizontale Scrollbar */
  box-sizing: border-box;
}

.email-body::-webkit-scrollbar {
  height: 14px; /* höher für horizontales Scrollen */
}

.email-body::-webkit-scrollbar-thumb {
  background-color: #999;
  border-radius: 8px;
}

.email-body::-webkit-scrollbar-track {
  background-color: #eee;
}


.error-message {
  color: red;
  font-weight: bold;
  margin: 10px 0;
}

.loading-spinner {
  text-align: center;
  font-size: 1.2em;
  color: #007bff;
  margin: 20px 0;
}

.xlsx-preview {
  margin-top: 20px;
  padding: 10px;
  background-color: #ffffff;
  border: 1px solid #ccc;
  overflow: auto;
  max-height: 50vh; /* Dynamisch, aber begrenzt */
  font-size: 13px;
  box-sizing: border-box;
}

.xlsx-preview table {
  width: 100%;
  table-layout: auto;
  border-collapse: collapse;
}

.xlsx-preview th,
.xlsx-preview td {
  padding: 6px;
  border: 1px solid #ccc; /* <<< genau das macht die Linien sichtbar */
  text-align: left;
  font-size: 13px;
  white-space: nowrap;
}

.pdf-preview {
  margin-top: 20px;
  border: 1px solid #ccc;
  padding: 10px;
  background-color: #fff;
  box-sizing: border-box;
}

.image-preview {
  margin-top: 20px;
  padding: 10px;
  background-color: #ffffff;
  border: 1px solid #ccc;
  text-align: center;
}


</style>

<style>
#excel-preview-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

#excel-preview-table th,
#excel-preview-table td {
  padding: 6px;
  border: 1px solid #ccc;
  text-align: left;
  white-space: nowrap;
}
</style>

